import { AsyncOperationsModel } from "../../../utility/AsyncOperationsModel";
import { observer } from "mobx-react";
import BaseComponent from "../../../utility/BaseComponent";
import * as React from "react";
import { Tabs, Tab, Paper , TabsContainer, Button, Divider, CircularProgress, ExpansionList, Snackbar, DialogContainer }
from "react-md";
import { observable, action, computed, runInAction } from "mobx";
import { IServicesProvider } from "../../../di/IServicesProvider";
import "./static/OrganisationSurveys.scss";
import { AddSurveyDialogModel } from "./AddSurveyDialog/AddSurveyDialog";
import { IOrganisation, IUser, OrganisationSurvey } from "../../../model/ModelTypes";
import { isNullOrUndefined } from "util";
import { BaseAdminOperations } from "../../../utility/admin/BaseAdminOperations";
import { IConfig } from "../../../IConfig";
import { OrganisationSurveysOperations }
from "../../../utility/admin/OrganisationOperations/OrganisationSurveysOperations/OrganisationSurveysOperations";
import AddSurveyDialog from "./AddSurveyDialog/AddSurveyDialog";
import OrganisationSurveyPanel from "../../../component/OrganisationSurveyPanel/OrganisationSurveyPanel";
const rootConfig: IConfig = require("Config"); 

export class OrganisationSurveysModel extends AsyncOperationsModel {
    @observable mobile: boolean = window.innerWidth < 768 ;
    @observable services: IServicesProvider;
    @observable addModel: AddSurveyDialogModel;
    @observable organisation: IOrganisation;
    @observable toasts: string[] = [];
    @observable operations: OrganisationSurveysOperations;
    @observable deleteDialogVisible: boolean = false;
    @observable onDeleteConfirmed: Function;
    @observable user: IUser;

    @computed get organisationSurveys(): OrganisationSurvey[] {
           return (this.organisation.organisation_surveys || []);
    }
    constructor(services: IServicesProvider) {
        super();
        this.services = services;
        window.addEventListener('resize', this.updateWidth);
        this.asyncOperationsCount = 0;
        this.user = this.services.getUser();
    }
    
    @action.bound
    updateWidth() {
        this.mobile = window.innerWidth < 768 ;
    }

    @action.bound
    onCreateClicked(event: React.MouseEvent<HTMLElement>) {
        this.addModel.setPageX(event.pageX);
        this.addModel.setPageY(event.pageY);
        this.addModel.setOrganisation(this.organisation);
        this.addModel.setDialogVisible(true);
    }

    @action.bound
    onOrganisationSurveyAdded(newSurvey: OrganisationSurvey) {
        if (!isNullOrUndefined(newSurvey)) {
                this.setToastMessage("New Survey Added");
        }
        this.addModel.addDisabled = false;
        this.addModel.setDialogVisible(false);
    }
    @action.bound
    setOperations(operations: OrganisationSurveysOperations) {
        this.operations = operations;
        operations.observeOrganisationChanges()
        .subscribe(this.setOrganisation, (error) => this.setErrorMessages(["Error Fetching Organisation Details"]));
        this.addModel =  new AddSurveyDialogModel(operations);
        this.addModel.onComplete = this.onOrganisationSurveyAdded;
        this.addModel.setUser(this.services.getUser());

    }

    @action.bound
    setOrganisation(organisation: IOrganisation) {
        this.organisation = organisation;
    }

    @action.bound
    prepare() {
        this.incrementAsyncOperations();
        BaseAdminOperations
        .build<OrganisationSurveysOperations>(
            OrganisationSurveysOperations,
            this.services.getDataStore(),
            this.services.getAdminServicesProvider()
            .getUsersControls()
            .getOperations()
            .getApi(),
            this.user.organisation,
            this.user,
            rootConfig
        ).subscribe(
            receivedOperations => {
                    runInAction( () => {
                        this.setOperations(receivedOperations);
                    });
            },
            error => {
                this.setErrorMessages(["Something Went Wrong"]);
            }  
        );
    }

    @action.bound
    onDeleteClicked(surveyToDelete: OrganisationSurvey ) {
        this.onDeleteConfirmed = () => {
            runInAction( () => {
                this.deleteDialogVisible = false;
                this.operations
                    .deleteSurvey(surveyToDelete.id)
                    .subscribe(success =>  this.setToastMessage("Survey Successfully Deleted"),
                               error => this.setToastMessage(error.toString()));
            } );
        };
        this.deleteDialogVisible = true;
    }
    @action.bound
    setToastMessage(message: string) {
        this.toasts = [message];
    }
    @action.bound
    onToastDismiss() {
        this.toasts = [];
    }

}

@observer class OrganisationSurveys extends BaseComponent<{model: OrganisationSurveysModel}, {}> {

    surveyButton = () => {
        return ( 
        <Button 
                raised={true} 
                secondary={true} 
                onClick={this.props.model.onCreateClicked}
        >Add New Survey
        </Button>
        );
    }
    noNotificationsMessage = () => {
        return (
            <div>
                <p>Add a survey by clicking on the button</p>
                {this.surveyButton()}
            </div>
        );
    }
    render() {
        return (
            <div className="root">
                {
                    isNullOrUndefined(this.props.model.organisation) &&
                    <CircularProgress centered={true} id="progress" />
                }
                {
                    !isNullOrUndefined(this.props.model.organisation) &&
                    <TabsContainer className="PushNotificationTabsContainer" panelClassName="md-grid" colored={true}>
                    <Tabs tabId="simple-tab" mobile={this.props.model.mobile}>
                    <Tab className="PushNotificationTab" label="Active Surveys">
                        <Paper zDepth={0} className="PushNotificationCardItem">
                            <div className="PushNotificationsCreateContainer">
                                {this.surveyButton()}
                            </div>
                            <Divider />
                            <div className="PushNotificationsTabViewContainer">
                                {
                                    (isNullOrUndefined(this.props.model.organisation.organisation_surveys) ||
                                    this.props.model.organisation.organisation_surveys.length === 0 ) &&
                                    this.noNotificationsMessage() 
                                }
                                {
                                    (!isNullOrUndefined(this.props.model.organisation.organisation_surveys) &&
                                    this.props.model.organisation.organisation_surveys.length > 0 ) &&
                                    <ExpansionList>
                                        {
                                            this.props.model.organisation.organisation_surveys.map(
                                                (survey, index) => {
                                                    return (<OrganisationSurveyPanel
                                                        key={survey.id}
                                                        survey={survey}
                                                        onDeleteClicked={this.props.model.onDeleteClicked}
                                                    />);
                                                }
                                            )
                                        }
                                    
                                    </ExpansionList>
                                }
                            </div>
                        </Paper>
                    </Tab>
                    </Tabs>
                    </TabsContainer>
                }
                {
                    !isNullOrUndefined(this.props.model.organisation) &&
                    <AddSurveyDialog model={this.props.model.addModel}/>
                }
                <DialogContainer
                        id="simple-action-dialog"
                        visible={this.props.model.deleteDialogVisible}
                        onHide={() => this.props.model.deleteDialogVisible = false}
                        title="Confirm Delete"
                        actions={[
                            <Button
                                key="cancel"
                                flat={true}
                                onClick={() => this.props.model.deleteDialogVisible = false}
                                className='CancelDelete'
                            >
                            Cancel
                            </Button>,
                            <Button
                                key="delete"
                                flat={true}
                                onClick={
                                    () => this.props.model.onDeleteConfirmed()   
                                }
                                className='ConfirmDelete'
                            >
                            Delete
                            </Button>

                        ]}
                        className='DeleteConfirmation'
                >
                    <p> Are you sure you want to delete this item?</p>
                        
                </DialogContainer>
                <Snackbar
                    id="snackbar"
                    toasts={this.props.model.toasts.map(item => {
                        return {
                            text: item
                        };
                    })}
                    autohide={true}
                    onDismiss={this.props.model.onToastDismiss}
                />
            </div>
                    
        );
    }
}
export default OrganisationSurveys;


// WEBPACK FOOTER //
// ./src/view/Admin/OrganisationSurveys/OrganisationSurveys.tsx